import { ProgramLinksSlider } from '../../../js/src/__utils/sliders';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		ProgramLinksSlider.init();
	},
	loaded() {},
	resized() {
		ProgramLinksSlider.init();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
